// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const cfg = () => window['globalConfiguration'];

export const clientHostname =  cfg()?.clientHostname || 'securebrowserreceiverdev.blob.core.windows.net';
export const sessionServiceApi = cfg()?.sessionServiceApi || 'https://session.browser.cloudtamale.com/[customer]';
export const captchaKey = cfg()?.captchaKey || '6Lc7vrAZAAAAALRFffDEQKtwwJx_iHn1xpb3-bT0';
export const resizeOverlayDuration = cfg()?.resizeOverlayDuration || '250';
export const receiverVersion = cfg()?.receiverVersion || '23.01.1.1';
export const allowExternalClient = cfg()?.allowExternalClient || true;
export const alternateReceiverUrl = cfg()?.alternateReceiverUrl || 'ctxsbclientdevwusstorage.blob.core.windows.net';
export const wasmCgpEnabled = cfg()?.receiverVersion?.includes('wasm') || false;